<template>
    <div class="w-full pb-3">
        <div v-if="!loading" class="w-full mb-3">
            <span v-if="total==0" class="block text-800 mb-3">{{ content[lang_].zero_bills }}</span>
            <!-- <Button :label="content[lang_].btn_create" @click="go_to_create()" class="flex flex-initial p-button-base border-round-lg mr-2" icon="pi pi-plus" iconPos="right" /> -->
        </div>
        
        <Bills :bills="bills" :total="total"/>

        <div v-if="!loading && bills && total>0" class="surface-0 border-round-xl overflow-hidden mb-3">
            <Paginator v-model:first="skip" :rows="10" :totalRecords="total" template="PrevPageLink PageLinks NextPageLink " />
        </div>
    </div>
</template>
  
<script>
import Connect from         '@/assets/js/Connect'
import Helper from          '@/assets/js/Helper'
import Bills from           '@/components/personal/bill/List.vue'
import { mapActions } from  'vuex'

export default {
    data() {
        return {
            header: {
                en: {title: "My bills"} ,
                ru: {title: "Мои счета"} ,
            },
            content: {
                ru: {
                    zero_bills: 'У вас пока нет счетов',
                    btn_create: 'Создать счет'
                },
                en: {
                    zero_bills: 'You don`t have bills yet',
                    btn_create: 'Create a bill'
                },
            },
            bills: null,
            total: null,
            skip: 0,
            loading: false
        }
    },
    components: {
        Bills
    },
    methods: {
        ...mapActions(['UpdateHeader']),
        updateHeader() {
            this.UpdateHeader({
                title: this.header[this.lang_].title,
                backButton: true,
                backButtonUrl: (this.wallet_id) ? `/personal/wallet/${this.wallet_id}` : '/personal/products/',
                profileButton: false
            });
        },
        go_to_create(){
            this.$router.push({ path: '/personal/bill/create/' })
        },
        showMess(severity, summary, detail) {
            try{ this.$toast.add({ severity: severity, summary: summary, detail: detail, life: 3000 }) }
            catch(e) { console.log('error showMess', e) }
        },
        async loadBills() {
            this.loading = true
            let bills = {}
            try {
                bills = await this.connect.personal_bills(this.lazyParams.rows, this.lazyParams.first).then(res => res)
                console.log('loadBills', bills)
                if (bills.result && bills.data) {
                    this.bills = bills.data
                    this.total = bills.total
                    this.loading = false
                }
                if(!bills.result){
                    this.bills = null
                    this.total = 0
                    this.loading = false
                    if(bills.errors && bills.errors.length > 0 ){
                        for (let i = 0; i < bills.errors.length; i++) {
                            this.showMess('error', this.content[this.lang_].error, bills.errors[i])
                        }
                    }
                }
            } catch (error) {
                this.bills = null
                this.total = 0
                this.loading = false
                this.showMess('error', this.content[this.lang_].error, error)
            }
        }
    },
    watch: {
        skip(){
            window.scrollTo({ top: 0, behavior: 'smooth' })
            this.lazyParams.first = this.skip
            this.loadBills()
        }
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        isDarkTheme() { return this.$store.getters.StateDarkTheme },
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
    mounted() {
        this.helper.SetTgAppHeadColor('white', this.isDarkTheme)
        this.updateHeader()
        this.lazyParams = {
            first: 0,
            rows: 10,
            sortField: null,
            sortOrder: null,
            filters: this.filters,
        };
        this.loadBills();
    },
}
</script>